export default {
  BROKER_SITE: 'Site do Corretor',
  NEW_SEARCH: 'Nova busca',
  SEARCH_IMMOBILE: 'Buscar imóvel',
  ADVERTISE: 'Anuncie seu imóvel',
  TO_BROKERS: 'Para corretores',
  VISIT: 'Agendar visita',
};
